module.exports = __webpack_public_path__ + "img/DocumentDetail.5da46a70.svg";